var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-182 -44.801)"},[React.createElement("path",{"data-name":"Path 10206","d":"M280.051,140.106V123.2h-1.322v16.906l-2.842-2.829-.925.925,3.965,3.965h.925l3.965-3.965-.925-.925Z","transform":"translate(-87.476 -73.773)","fill":"#fff","key":0}),React.createElement("path",{"data-name":"Path 10207","d":"M182,71.9l.661.661h18.505l.661-.661V45.462l-.661-.661H182.661l-.661.661Zm1.322-25.775h17.184V71.237H183.322Z","fill":"#fff","key":1})]));
}

ArrowDown.defaultProps = {"width":"19.827","height":"27.758","viewBox":"0 0 19.827 27.758"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
